import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { CountriesType } from "types/CountriesTypes";

export default function useGetCountriesShort() {
  return useQuery({
    queryKey: ["countries/short"],

    queryFn: async () => {
      return axiosInstance.get(`countries/short`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: CountriesType[]) => data,
    staleTime: 1000 * 60 * 60 * 24,
  });
}
